import { render, staticRenderFns } from "./WalletTransaction.vue?vue&type=template&id=55481ad8"
import script from "./WalletTransaction.vue?vue&type=script&lang=js"
export * from "./WalletTransaction.vue?vue&type=script&lang=js"
import style0 from "./WalletTransaction.vue?vue&type=style&index=0&id=55481ad8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports